/***************************************************************************
 * Scrolls to the first errored field on a form and moves focus to it, so a
 * failed submission leaves the user on the field they need to fix rather
 * than at the top of the page.
 *
 * errorElements - array of jQuery objects holding an error message or an
 *                 error wrapper. Hidden or unpositioned entries are ignored.
 * context       - the form the errors belong to, used to scope field lookup.
 **************************************************************************/
ht.scrollToFirstError = function (errorElements, context) {
  try {
    const firstError = ht.findFirstErroredField(errorElements, context);
    if (firstError === null) {
      return;
    }

    // the errored field is the target, so focus it outright: keyboard and
    // screen reader users land on the input that needs fixing
    ht.focusWithoutScrolling(firstError.field);

    // scrolling puts the anchor flush against the top of the viewport, so
    // when a form renders its message above the field, anchor on the
    // message instead or it would be clipped out of view
    const anchorPosition = ht.topOf(
      ht.topmostElement(firstError.field, firstError.message)
    );
    if (anchorPosition !== null) {
      $(window).scrollTop(anchorPosition);
    }
  } catch (e) {
    ht.log(e);
  }
};

/***************************************************************************
 * Picks the errored field closest to the top of the page and returns it
 * with the message describing it, as {field, message}, or null when
 * nothing on the form is targetable. An error whose field cannot be
 * resolved is ranked by its message position instead, so a form that only
 * renders a summary message still gets a sensible target.
 **************************************************************************/
ht.findFirstErroredField = function (errorElements, context) {
  let firstError = null;
  let firstErrorTop = null;

  $.each(errorElements, function () {
    const message = $(this);
    if (!ht.isVisibleErrorElement(message)) {
      return;
    }

    const field = ht.findFieldForError(message, context);
    const candidateTop = ht.topOf(field.length > 0 ? field : message);
    if (candidateTop === null) {
      return;
    }

    if (firstError === null || candidateTop < firstErrorTop) {
      firstError = {field: field, message: message};
      firstErrorTop = candidateTop;
    }
  });

  return firstError;
};

/***************************************************************************
 * Distance from the top of the document, or null when the element is
 * absent or has no resolvable position.
 **************************************************************************/
ht.topOf = function (element) {
  if (element === null || element.length < 1) {
    return null;
  }
  const offset = element.offset();
  return offset ? offset.top : null;
};

/***************************************************************************
 * Returns whichever of the two elements sits higher on the page. Elements
 * without a resolvable position lose to any positioned element.
 **************************************************************************/
ht.topmostElement = function (current, candidate) {
  const candidatePosition = ht.topOf(candidate);
  if (candidatePosition === null) {
    return current;
  }
  const currentPosition = ht.topOf(current);
  if (currentPosition === null) {
    return candidate;
  }
  return candidatePosition < currentPosition ? candidate : current;
};

/***************************************************************************
 * An error element counts only when it is on screen and positioned.
 **************************************************************************/
ht.isVisibleErrorElement = function (errorElement) {
  return (
    errorElement.length > 0 &&
    errorElement.is(':visible') &&
    ht.topOf(errorElement) !== null
  );
};

/***************************************************************************
 * Resolves the form field an error element describes. Error labels in this
 * app carry a `for` attribute that may list several field names, and error
 * wrappers carry no `for` at all, so both shapes are handled. When a label
 * names several fields the topmost visible one wins.
 **************************************************************************/
ht.findFieldForError = function (errorElement, context) {
  const forAttr = errorElement.attr('for');
  let field = null;

  if (forAttr) {
    const names = $.trim(forAttr).split(/\s+/);
    for (let i = 0; i < names.length; i++) {
      field = ht.topmostElement(field, ht.findFieldByName(names[i], context));
    }
  }

  if (field === null) {
    const nested = errorElement.find(':input').filter(':visible').first();
    if (nested.length > 0) {
      field = nested;
    }
  }

  return field === null ? $() : field;
};

/***************************************************************************
 * Looks a field up by name, then by id, restricted to visible elements
 * inside the given form.
 **************************************************************************/
ht.findFieldByName = function (name, context) {
  const field = $(context)
    .find('[name="' + name + '"]')
    .filter(':visible')
    .first();
  if (field.length > 0) {
    return field;
  }
  // getElementById avoids throwing on names that are not valid selectors
  const byId = document.getElementById(name);
  if (byId) {
    return $(byId).filter(':visible').first();
  }
  return $();
};

/***************************************************************************
 * Focuses a field without letting the browser scroll it into view, so the
 * caller keeps control of the final scroll position.
 **************************************************************************/
ht.focusWithoutScrolling = function (field) {
  if (field.length < 1) {
    return;
  }
  const node = field[0];
  try {
    node.focus({preventScroll: true});
  } catch (e) {
    node.focus();
  }
};
